var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyBcmeaHorizontalRgbWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 521",
    width: 1200,
    height: 521,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MyBCMEA Horizontal RGB_White-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: #ffffff } \r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BROKEN"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m597.6 245.2l-23.5 57.7h-5.6l-23.4-57.7v57.7h-13.4v-75.9h19l20.6 51.3 20.6-51.3h19v75.9h-13.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m631.5 314.6c3.7 0 6.5-1.2 7.7-4.8l2.8-6.5-22.6-55.7h12.9l16.2 41.2 16.1-41.2h13l-26.7 65c-3.6 9.3-10.5 12.5-19 12.5-1.6 0-4.8 0-6.8-0.8l2-10.9c1.2 0.4 3.2 0.8 4.4 0.8z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "FIXED"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s0",
    d: "m684.1 304.6v-78.8h38.7c14.5 0 22.5 9 22.5 20.1 0 9.8-6.4 16.5-13.7 18.1 8.5 1.3 15.2 9.7 15.2 19.2 0 12.3-8 21.4-22.9 21.4zm47-56.5q0 0 0 0 0 0 0 0zm-11-10.1h-22.2v20.3h22.2c7 0 11-4.1 11-10.2 0-5.7-4-10.1-11-10.1zm12.6 43.5c0-5.9-4.1-11-11.9-11h-22.9v21.9h22.9c7.4 0 11.9-4.1 11.9-10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m757.3 265.3c0-24.4 18.1-40.8 41.4-40.8 15.9 0 25.8 8.2 31.6 17.6l-11.7 6.2c-3.8-6.7-11.5-11.5-19.9-11.5-15.6 0-27.2 11.8-27.2 28.5 0 16.6 11.6 28.4 27.2 28.4 8.4 0 16.1-4.9 19.9-11.4l11.8 5.9c-6 9.4-15.8 17.8-31.7 17.8-23.3 0-41.4-16.5-41.4-40.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m909.5 304.6v-60.8l-24.2 60.8h-5.9l-24.2-60.8v60.8h-13.8v-78.8h19.5l21.5 54.1 21.4-54.1h19.5v78.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m940.1 304.6v-78.8h54v12.2h-40.2v20.3h39.4v12.1h-39.4v22h40.2v12.2h-54z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s0",
    d: "m1063.6 304.6l-5.8-15.2h-36.1l-5.8 15.2h-15.7l30.9-78.8h17.3l30.9 78.8zm-23.9-65l-14.1 37.6h28.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "test4",
    className: "s0",
    d: "m459.6 295.3c0 0-44-110.2-86.5-130.4-3-1.5-7.8-1.1-12 1.4-9.8 5.8-25 18.8-35.6 31.5-23.2-34.4-52.4-71.3-72.6-71.3-6.8 0-12 3.7-14.7 5.9-70.4 55.3-106.6 186.1-106.6 186.1 0 0 40.2-45 164-9 123.8 36 163.9-14.2 163.9-14.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "test3",
    className: "s0",
    d: "m458.8 313.9c0 0-25.1 36-65 41.6-22.8 3.2-54 4.4-87.2-12.1-78.1-38.8-118.8-34.4-118.8-34.4 28.8-11.1 86.7 6 110.2 14.3 23.5 8.4 99.6 34.7 160.8-9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "test2",
    className: "s0",
    d: "m446.4 344.7c0 0-59.6 55.3-156.3 5.3-125.7-65.1-163.9-9.1-163.9-9.1 0 0 47.1-33 129 20.6 95.8 62.7 162.9 22.1 191.3-16.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "test",
    className: "s0",
    d: "m135.6 345.6c0 0 45.3-17.8 97.2 16.2 18.5 12.1 23.2 14.2 44.5 25.2 0 0-44.5 4-76.3-17.8-35.4-24.1-65.4-23.6-65.4-23.6z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyBcmeaHorizontalRgbWhite);
export default __webpack_public_path__ + "static/media/MyBCMEA Horizontal RGB_White.58f70b7832977bf21a73019ede139f98.svg";
export { ForwardRef as ReactComponent };